import { formatDate } from 'utils';

export function USDate({
  date,
  className = '',
  format = 'short',
}: {
  date?: Date | string | string;
  className?: string;
  format?: 'long' | 'short';
}) {
  if (!date) return null;

  let value: Date;

  value = typeof date === 'string' ? new Date(date) : date;

  return (
    <span className={`whitespace-nowrap ${className}`}>
      {date &&
        formatDate(value, format === 'short' ? 'us-date' : 'long-us-date')}
    </span>
  );
}
